















































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
/* component */
import FieldImg from '@/app/components/Field/FieldImg.vue'
import AiAdvicePlans from '@/app/components/FieldDetails/AiAdvicePlans.vue'
import Fertilization from '@/app/components/FieldDetails/Fertilization.vue'
import Loading from '@/app/components/Common/Loading.vue'
/* module */
import Local from '@/app/module/local'
import { sensorData } from '@/app/model/store/domain/types'
import Session from '@/app/module/session'
import DateClass from '@/app/module/date'
import { harvestStatus } from '@/app/model/store/domain/const'
/* api */
import triartApi from '@/app/model/api/triartApi'

@Component({
  components: {
    FieldImg,
    AiAdvicePlans,
    Fertilization,
    Loading
  }
})
export default class DetailsContent extends Vue {
  /* アイコン */
  private stemIcon: string = require('@/assets/icon/ico_condition3.png')
  private stemM2Icon: string = require('@/assets/icon/ico_condition3.png')
  private growthHeightIcon: string = require('@/assets/icon/ico_condition2.png')
  private leafColorIcon: string = require('@/assets/icon/ico_condition1.png')
  private spadIcon: string = require('@/assets/icon/ico_condition2.png')
  private waterLevelIcon: string = require('@/assets/icon/ico_condition1.png')
  private waterTemperatureIcon: string = require('@/assets/icon/ico_condition2.png')
  private earthTemperatureIcon: string = require('@/assets/icon/ico_condition1.png')
  private growthImgPath: string = require('@/assets/icon/ico_cultivation3.png')
  private weatherIcon: string = require('@/assets/icon/weather_unknown.svg')
  private imgPath: string = ''
  /* 表示非表示 */
  private isActiveSickness: boolean = false
  private isActiveWeeds: boolean = false
  private isActivePest: boolean = false
  private isActiveTempareture: boolean = false
  private isActiveLoading: boolean = false
  private isCondition: boolean = false
  private disabled: boolean = false
  private showFutureData: boolean = true
  private isActive: string = 'growthData'
  /* データ */
  private plantingId: number = 0
  private maxIntegrationTemperature: number = 2600
  private allGraphData: {[key: number]: any } = {}
  private sensorDataList: any[] = []
  private graphData: {[key: string]: number} = {
    growth_height: 0,
    integration_temperature: 0,
    soil_moisture: 0,
    spad: 0,
    stem_number: 0,
    stem_number_m2: 0
  }
  private sensorData: any = {
    growth_stage: '-',
    growth_step: 0,
    intergration_temperature: 0,
    max_integration_temperature: 2600,
    field_status: {
      is_sick: false,
      is_weed: false,
      is_pest: false,
      is_high_temperature: false,
      is_lodging: false
    },
    growth_status: {
      stem_number: null,
      stem_number_m2: null,
      plant_height: null
    },
    nutrition_status: {
      leaf_age: null,
      spad: null
    },
    is_fieldcam_sensor: false,
    image_analysis_status: null,
    weather_status: {
      weather_code: null,
      temperature: null,
      temperature_highest: null,
      temperature_lowest: null,
      temperature_difference: null,
      solar_radiation: null,
      windy_time: null,
      humidity: null,
      rainfall: null,
      wind_velocity: null
    },
    plant_status: {
      water_level: null,
      water_temperature: null,
      soil_temperature: null
    },
    deep_water_pointer: {
      pointer_water_level: null,
      pointer_water_temperature: null,
      water_compliance_rate: null
    },
    image_path: require('@/assets/icon/ico_cultivation2.png'),
    date: 0
  }
  private currentDate: string = ''
  private keyDate: string = ''
  private keyWeekDay: string = ''
  private getImgKey: string = ''
  private latestDate: string = ''
  private stemNumType: string = '1'
  private fsSensorKey: string = ''
  private pwSensorKey: string = ''
  private fcSensorKey: string = ''
  // midsummer-drainage
  private midsummerDrainage: any = {}

  private get forceDateChangeFlag (): boolean {
    return this.$store.state.dateChoiceState.forceChangeDateFlag
  }
  private get dateChangeState (): number {
    return this.$store.state.dateChoiceState.changeDate
  }
  private get setSensorDataFlag () : boolean {
    return this.$store.state.setFlagState.sensorDataFlag
  }
  private get setWaterComplianceRateFlag () : boolean {
    return this.$store.state.setFlagState.waterComplianceRateFlag
  }
  private get setMaxDate (): string {
    return this.$store.state.fieldDetailsState.maxDate
  }
  private get displayYear (): number {
    return this.$store.state.fieldDetailsState.displayYear
  }
  @Watch('displayYear')
  changeDisplayYaer () {
    this.firstFlag = true
  }
  @Watch('forceDateChangeFlag')
  onForceDateChangeed (flag: boolean) {
    if (!flag) {
      return
    }
    this.onDateChange(this.$store.state.dateChoiceState.changeDate)
  }
  @Watch('dateChangeState')
  onDateChange (newValue: string) {
    this.currentDate = newValue
    this.setCurrentDayAsDisp(newValue)
    let plantingId = Session.getPlantingId()!
    this.plantingId = parseInt(plantingId)

    /* 画像取得APIのためのkeyを保存 */
    this.getImgKey = newValue

    this.getDetailsData(newValue)
    this.updateMidsummerDrainage()
  }
  @Watch('setSensorDataFlag')
  getFlag (flag: boolean) {
    if (flag) {
      this.getSensorData()
      const fertilizationRef: any = this.$refs.fertilization
      if (fertilizationRef) {
        fertilizationRef.onSensorDataChanged()
      }
      this.initDownloadButton()
      /* フラグリセット */
      this.$store.commit('setFlagState/setSensorDataFlag', false)
    }
  }
  @Watch('setWaterComplianceRateFlag')
  getwaterComplianceRateFlag (flag: boolean) {
    if (flag) {
      this.getWaterComplianceRateData()
      /* フラグリセット */
      this.$store.commit('setFlagState/setWaterComplianceRateFlag', false)
    }
  }
  @Watch('setMaxDate')
  getMaxDate (day: string) {
    if (day !== '') {
      this.getGraphData()
    }
  }
  @Watch('tabResetFlag')
  getTabResetFlag (flag: boolean) {
    if (flag) {
      this.isActive = 'growthData'
      /* フラグリセットデータを送信 */
      this.$emit('flag-reset')
    }
  }

  @Prop() private aiAdvicePlans!: any
  @Prop() private aiAdviceName!: any
  @Prop() private showAiAdviceLoading!: boolean
  @Prop() private tabResetFlag!: boolean

  private changeTab (val: string) {
    this.isActive = val
  }

  created () {
    this.cacheClear()
  }

  private displayValue (value: number|string) {
    return value !== null && value !== undefined ? value : '-'
  }

  private jugeStatusIcon (data: any, key: string) {
    if (data === null || data[key] === null || data[key] !== 1) {
      return require('@/assets/icon/no_data.png')
    } else {
      return require('@/assets/icon/ico_condition1.png')
    }
  }

  private async cacheClear () {
    await Session.clearSensorCache()
    await Session.clearWaterComplianceRateCache()
  }

  private getStageNum (stageName: string) {
    if (stageName === null || stageName === '-') {
      return ''
    } else {
      const num = stageName.split('.', 1)
      return num[0] + '.'
    }
  }

  private getStageName (stageName: string) {
    let name = stageName.split('.', 2)
    return name[1]
  }

  /* センサーデータをsessionStorageから取得 */
  private async getSensorData () {
    let plantingId = Session.getPlantingId()!
    this.allGraphData = JSON.parse(Session.getGraphData()!)
    let sensorDataList = await JSON.parse(Session.getSensorData(plantingId)!)
    this.stemNumType = Session.getStemNumberType()!

    if (sensorDataList !== null) {
      if (Object.keys(sensorDataList).length === 1) {
        // timestamp以外のデータがないとき
        this.keyDate = '-月-日'
        this.keyWeekDay = '-'
        this.disabled = true
      } else {
        this.sensorDataList = JSON.parse(Session.getSensorData(plantingId)!)
      }
    }
    this.getDetailsData(this.latestDate)
  }

  private waterComplianceRateData: any = []

  /* 水遵守率データをsessionStorageから取得 */
  private async getWaterComplianceRateData () {
    const plantingId = Session.getPlantingId()!
    let waterComplianceRateDataList = await JSON.parse(Session.getWaterComplianceRateData(plantingId)!)

    if (Object.keys(waterComplianceRateDataList).length !== 1) {
      this.waterComplianceRateData = waterComplianceRateDataList
      this.setWaterComplianceRateData()
    }
  }

  private setWaterComplianceRateData () {
    for (var j in this.waterComplianceRateData) {
      if (this.createYYYYMMDD(this.waterComplianceRateData[j].record_date) === String(this.getImgKey)) {
        this.sensorData.deep_water_pointer.water_compliance_rate = this.waterComplianceRateData[j].water_compliance_rate
        break
      }
    }
  }

  private initDownloadButton () {
    const allGraphData: any = JSON.parse(Session.getAllGraphData()!)
    this.fsSensorKey = allGraphData.field_sensor_key.fs_sensor_key
    this.pwSensorKey = allGraphData.field_sensor_key.pw_sensor_key
    this.fcSensorKey = allGraphData.field_sensor_key.fc_sensor_key
  }

  // midsummer-drainage
  private updateMidsummerDrainage () {
    const midsummerDrainage = JSON.parse(Session.getMidsummerDrainage()!)
    if (Object.keys(midsummerDrainage).length === 0) {
      this.midsummerDrainage = {}
      return
    }
    const term: any = midsummerDrainage.start_date && midsummerDrainage.end_date ? {
      startDate: DateClass.parseInt(midsummerDrainage.start_date),
      endDate: DateClass.parseInt(midsummerDrainage.end_date)
    } : {
      startDate: DateClass.parseInt(midsummerDrainage.goal_start_date),
      endDate: DateClass.parseInt(midsummerDrainage.goal_end_date)
    }
    const today = parseInt(this.currentDate)
    const period: string = today < term.startDate ? '中干し前'
      : today < term.endDate ? '中干し中' : '中干し完了'
    const termDays: number = DateClass.daysCalculation(term.startDate, term.endDate) + 1
    const count: number = Math.max(0, Math.min(termDays, DateClass.daysCalculation(term.startDate, today) + 1))
    this.midsummerDrainage = {
      period: period,
      start: term.startDate,
      end: term.endDate,
      termDays: termDays,
      count: count,
      remain: termDays - count
    }
  }

  private createYYYYMMDD (date: string) {
    const year = String(date).slice(0, 4)
    const month = String(date).slice(5, 7)
    const day = String(date).slice(8, 10)

    return '' + year + month + day
  }

  private firstFlag: boolean = true

  private getGraphData () {
    /* 取得したデータの最新を表示 */
    if (this.allGraphData === null) {
      return
    }

    /* 取得したデータの最新、または、グラフの最終日を表示 */
    let dataLastDate: string = String(Object.keys(this.allGraphData).pop())
    let graphLastDate: number = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let keyDate: string

    if (parseInt(dataLastDate) > graphLastDate) {
      keyDate = String(graphLastDate)
    } else {
      keyDate = dataLastDate
    }
    this.latestDate = keyDate

    if (this.firstFlag) {
      this.firstFlag = false
      this.$store.commit('dateChoiceState/setChangeDate', keyDate)
      this.setCurrentDayAsDisp(keyDate)
    }

    if (this.allGraphData !== null && Object.keys(this.allGraphData).length !== 0) {
      this.getDaysTodate(keyDate)
      let plantingId = Session.getPlantingId()!

      /* 詳細データがある場合は表示 */
      if (this.allGraphData[parseInt(keyDate)]) {
        this.graphData = this.allGraphData[parseInt(keyDate)]
      }
    }

    // this.showDetailLoading = false
  }

  /* センサーデータ取得 */
  private getDetailsData (key:string) {
    // 全データなし
    if (this.sensorDataList.length === 0) {
      this.showFutureData = true
      return
    }

    this.sensorData = {
      growth_stage: '-',
      growth_step: 0,
      intergration_temperature: 0,
      max_integration_temperature: 2600,
      field_status: {
        is_sick: false,
        is_weed: false,
        is_pest: false,
        is_high_temperature: false,
        is_lodging: false
      },
      growth_status: {
        stem_number: null,
        stem_number_m2: null,
        plant_height: null
      },
      nutrition_status: {
        leaf_age: null,
        spad: null
      },
      is_fieldcam_sensor: false,
      image_analysis_status: null,
      weather_status: {
        weather_code: null,
        temperature: null,
        solar_radiation: null,
        windy_time: null,
        humidity: null,
        rainfall: null,
        wind_velocity: null
      },
      plant_status: {
        water_level: null,
        water_temperature: null,
        soil_temperature: null
      },
      deep_water_pointer: {
        pointer_water_level: null,
        pointer_water_temperature: null,
        water_compliance_rate: null,
        water_level_range: null,
        water_control_name: null
      },
      image_path: require('@/assets/icon/ico_cultivation2.png'),
      date: 0
    }

    for (var j in this.sensorDataList) {
      if (this.sensorDataList[j].date === parseInt(key)) {
        this.maxIntegrationTemperature = this.sensorDataList[j].max_intergration_temperature
        this.sensorData = this.sensorDataList[j]
        // センサーのデータを参照しないようにnullをセット
        this.sensorData.deep_water_pointer.water_compliance_rate = null
        break
      }
    }
    this.setWaterComplianceRateData()

    // データが無かったら表示
    if (this.sensorData.growth_stage === '-') {
      this.showFutureData = true
    } else {
      this.showFutureData = false
    }

    this.judgmentWorning()
    this.judgmentIconColor()
    this.judgmentGrowthImg()
    this.judgmentWeatherIcon()
    this.setImagePath()
  }

  private remainingIntegrationTemperature (val: number) {
    if (val === undefined || val === null) {
      return '-'
    } else {
      const remainingIntegrationTemp = this.maxIntegrationTemperature - this.sensorData.integration_temperature
      if (remainingIntegrationTemp < 0) {
        return 0
      } else {
        return remainingIntegrationTemp
      }
    }
  }

  /* 圃場状態アイコンの判定 */
  private judgmentWorning () {
    this.isActiveSickness = this.sensorData.field_status.is_sick
    this.isActiveWeeds = this.sensorData.field_status.is_weed
    this.isActivePest = this.sensorData.field_status.is_pest
    this.isActiveTempareture = this.sensorData.field_status.is_high_temperature
    this.isActiveLoading = this.sensorData.field_status.is_lodging

    if (this.isActiveSickness || this.isActiveWeeds || this.isActivePest || this.isActiveTempareture || this.isActiveLoading) {
      this.isCondition = true
    } else {
      this.isCondition = false
    }
  }

  /* 詳細アイコンの判定 */
  private judgmentIconColor () {
    /* 茎数 */
    if (this.sensorData.growth_status.stem_number === null || this.sensorData.growth_status.stem_number === null) {
      this.stemIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.goal_stem_number > this.sensorData.growth_status.stem_number) {
      // 目標より小さい場合は注意アイコン
      this.stemIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.stemIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* 茎数 */
    if (this.sensorData.growth_status.stem_number_m2 === null || this.sensorData.growth_status.stem_number_m2 === null) {
      this.stemM2Icon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.goal_stem_number_m2 > this.sensorData.growth_status.stem_number_m2) {
      // 目標より小さい場合は注意アイコン
      this.stemM2Icon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.stemM2Icon = require('@/assets/icon/ico_condition1.png')
    }

    /* 草丈 */
    if (this.sensorData.growth_status.plant_height === null || this.sensorData.growth_status.plant_height === null) {
      this.growthHeightIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.goal_plant_height > this.sensorData.growth_status.plant_height) {
      // 目標より小さい場合は注意アイコン
      this.growthHeightIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.growthHeightIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* NDVI */
    if (this.sensorData.nutrition_status.leaf_age === null || this.sensorData.nutrition_status.leaf_age === null) {
      this.leafColorIcon = require('@/assets/icon/no_data.png')
    } else {
      this.leafColorIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* 葉色値 */
    if (this.sensorData.nutrition_status.spad === null || this.sensorData.nutrition_status.spad === null) {
      this.spadIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.goal_spad > this.sensorData.nutrition_status.spad) {
      // 目標より小さい場合は注意アイコン
      this.spadIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.spadIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* 水位 */
    if (this.sensorData.plant_status.water_level === null || (this.sensorData.deep_water_pointer.water_level_upper_limit === null &&
        this.sensorData.deep_water_pointer.water_level_lower_limit === null)) {
      this.waterLevelIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.water_level_lower_limit > this.sensorData.plant_status.water_level ||
               this.sensorData.deep_water_pointer.water_level_upper_limit < this.sensorData.plant_status.water_level) {
      // 下限よりも小さいもしくは上限より大きい場合は注意アイコン
      this.waterLevelIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.waterLevelIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* 水温 */
    if (this.sensorData.plant_status.water_temperature === null || (this.sensorData.deep_water_pointer.water_temp_lower_limit === null &&
        this.sensorData.deep_water_pointer.water_temp_upper_limit === null)) {
      this.waterTemperatureIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.water_temp_lower_limit > this.sensorData.plant_status.water_temperature ||
               this.sensorData.deep_water_pointer.water_temp_upper_limit < this.sensorData.plant_status.water_temperature) {
      // 下限よりも小さいもしくは上限より大きい場合は注意アイコン
      this.waterTemperatureIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.waterTemperatureIcon = require('@/assets/icon/ico_condition1.png')
    }

    /* 地温 */
    if (this.sensorData.deep_water_pointer.goal_soil_temperature === null || this.sensorData.plant_status.soil_temperature === null) {
      this.earthTemperatureIcon = require('@/assets/icon/no_data.png')
    } else if (this.sensorData.deep_water_pointer.goal_soil_temperature > this.sensorData.plant_status.soil_temperature) {
      // 目標より小さい場合は注意アイコン
      this.earthTemperatureIcon = require('@/assets/icon/ico_condition3.png')
    } else {
      this.earthTemperatureIcon = require('@/assets/icon/ico_condition1.png')
    }
  }

  /* 天気アイコンの判定 */
  private judgmentWeatherIcon () {
    const weather = this.sensorData.weather_status.weather_code
    switch (weather) {
      // 晴れ
      case 1:
        this.weatherIcon = require('@/assets/icon/forecast_icon-sun_iphone.png')
        break

      // 曇り
      case 2:
        this.weatherIcon = require('@/assets/icon/forecast_icon-cloud_iphone.png')
        break

      // 雨
      case 3:
        this.weatherIcon = require('@/assets/icon/forecast_icon-rain_iphone.png')
        break

      // 雨または雪
      case 4:
        this.weatherIcon = require('@/assets/icon/forecast_icon-sleet_iphone.png')
        break

      // 雪
      case 5:
        this.weatherIcon = require('@/assets/icon/forecast_icon-snow_iphone.png')
        break

      // 不明
      default:
        this.weatherIcon = require('@/assets/icon/weather_unknown.svg')
        break
    }
  }

  /* 稲の画像判定 */
  private judgmentGrowthImg () {
    if (this.sensorData.growth_step === undefined) {
      return
    }

    if (this.sensorData.growth_step === 0) {
      let lastData = this.sensorDataList[this.sensorDataList.length - 1]
      this.sensorData.growth_step = lastData.growth_step
    }

    /**
     * 播種期～活着期＝1(1~3)
     * 無効分けつ～幼穂形成期=2(4~6)
     * 穂走り期～収穫適期=3(7~)
     */
    if (this.sensorData.growth_step >= 1 && this.sensorData.growth_step <= 3) {
      this.growthImgPath = require('@/assets/icon/ico_cultivation1.png')
    } else if (this.sensorData.growth_step >= 4 && this.sensorData.growth_step <= 6) {
      this.growthImgPath = require('@/assets/icon/ico_cultivation2.png')
    } else if (this.sensorData.growth_step >= 7) {
      this.growthImgPath = require('@/assets/icon/ico_cultivation3.png')
    }
  }

  /* 画像URL */
  private setImagePath () {
    const path = '/v1/field/image'
    let type = ''
    let id = Session.getPlantingId()!
    let date = '' + new Date().getFullYear() + (new Date().getMonth() + 1) + (new Date().getDate() - 1)

    var url = new URL(process.env.VUE_APP_API_URL + path)
    var params = new URLSearchParams({ type: type, planting_id: id, date: date })
    url.search = params.toString()
    this.imgPath = url.href
  }

  /* 日付と曜日の表示 */
  private setCurrentDayAsDisp (keyDate: string) {
    if (keyDate !== '0') {
      this.keyDate = DateClass.displayData(parseInt(keyDate))
      this.keyWeekDay = DateClass.setWeek(parseInt(keyDate))
    }
  }

  private displayDate (date: string) {
    return DateClass.displayData(parseInt(date))
  }

  /* 播種日からkeyDateまでの日数を取得 */
  private getDaysTodate (keyDate: string) {
    let plantingDay: number = parseInt(Session.getPlantingDay()!)
    // this.$store.commit('fieldDetailsState/setdaysToDate', DateClass.daysCalculation(plantingDay, parseInt(keyDate)))
  }

  /* 日付変更用(<、>ボタンクリック時) */
  private changeDetailDate (type: string) {
    const plantingDay = parseInt(Session.getPlantingDay()!)
    const status = parseInt(Session.getHarvestStatus()!)
    const harvestStatusDay = Session.getHarvestStatusDay()!
    const selectedDate = DateClass.formingDate(this.$store.state.dateChoiceState.changeDate)

    // 始まりを播種日-9日にする
    const minDay = DateClass.formingDate(plantingDay)
    minDay.setDate(minDay.getDate() - 9)
    const formingDate = this.formingData(minDay)
    const formingLastDate = this.formingData(this.$store.state.fieldDetailsState.maxDate)
    let maxDay = formingLastDate

    if (type === 'plus') {
      /* 現在の日付を時間に単位変換し、プラス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() + 1 * 24 * 60 * 60 * 1000)
      /* 数値型に変換 */
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 最終日より先の日付には変更不可 */
      if (setDate <= maxDay) {
        /* スライドバーを連動 */
        this.getDaysTodate(JSON.stringify(setDate))
        /* stateに保持 */
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    } else if (type === 'minus') {
      /* 現在の日付を時間に単位変換し、マイナス1日する */
      let newDate = new Date(new Date(selectedDate).getTime() - 1 * 24 * 60 * 60 * 1000)
      let setDate = parseInt('' + newDate.getFullYear() + DateClass.toDoubleDigits(newDate.getMonth() + 1) + DateClass.toDoubleDigits(newDate.getDate()))
      /* 播種日より前の日付は変更不可 */
      if (formingDate <= setDate) {
        this.getDaysTodate(JSON.stringify(setDate))
        this.$store.commit('dateChoiceState/setChangeDate', JSON.stringify(setDate))
      }
    }
  }

  private formingData (day: any) {
    const date = DateClass.toDoubleDigits(day.getFullYear()) + DateClass.toDoubleDigits(day.getMonth() + 1) + DateClass.toDoubleDigits(day.getDate())
    return parseInt(date)
  }

  /* 最大値の判定 */
  public judgeMaxDay (a: number, b:number) {
    let maxDay: any

    if (a >= b) {
      maxDay = a
    } else {
      maxDay = b
    }

    return maxDay
  }

  /* 小数点第二位以下切り上げ表示 */
  private displayTranslation (num: number) {
    return Math.ceil(num * Math.pow(10, 2)) / Math.pow(10, 2)
  }

  /* ステージバーの更新処理 */
  private reacquireStage () {
    this.$emit('reacquire-stage-data')
  }

  /* ローディングアイコン表示切り替え */
  private showLoading (disp: boolean) {
    if (disp) {
      this.$emit('show-loading')
    } else {
      this.$emit('disable-loading')
    }
  }

  private async openFW2CSVDownload (sensorKey: string) {
    const companyId: string = Local.getCompanyId()!
    const result: any = (await triartApi.findField(sensorKey, companyId)).getPayload()
    if (result.length === 0) {
      alert('fieldIDの取得に失敗しました。')
    } else {
      window.open('https://agri-note.jp/b/mizu.html#/csv_download/' + result[0].fieldid, '_blank')
    }
  }
}
